import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  headerPrimary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textAlign: "center",
  },
}));

const ActionDialog = ({
  open,
  title,
  children,
  onAccept,
  onClose,
  maxWidth = "md",
  textConfirm = "app.send",
  textButtonCancel = "app.close",
  enableHeader = true,
  enableConfirmButton = true,
  disableConfirmButton = false,
  textToConfirmation,
  backgroundPrimaryColor,
}) => {
  const classes = useStyles();
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);

  const handleConfirmClick = () => {
    if (textToConfirmation) {
      setShowConfirmDialog(true);
    } else {
      onAccept();
    }
  };

  const handleConfirmAccept = () => {
    setShowConfirmDialog(false);
    onAccept();
  };

  const handleConfirmCancel = () => {
    setShowConfirmDialog(false);
  };

  return (
    <>
      <Dialog
        fullWidth
        maxWidth={maxWidth}
        open={open}
        onClose={onClose}
      >
        {enableHeader && (
          <DialogTitle className={`${backgroundPrimaryColor ? classes.headerPrimary : ""}`}>
            <FormattedHTMLMessage id={title} />
          </DialogTitle>
        )}
        <DialogContent>{children}</DialogContent>
        <DialogActions style={{ marginTop: 20 }}>
          {enableConfirmButton && (
            <Button
              type="submit"
              onClick={handleConfirmClick}
              color="primary"
              fullWidth
              variant="contained"
              disabled={disableConfirmButton}
            >
              <FormattedMessage id={textConfirm} />
            </Button>
          )}
          <Button
            onClick={onClose}
            color="primary"
            fullWidth
            variant="outlined"
          >
            <FormattedMessage id={textButtonCancel} />
          </Button>
        </DialogActions>
      </Dialog>

      {textToConfirmation && (
        <Dialog
          open={showConfirmDialog}
          onClose={handleConfirmCancel}
        >
          <DialogTitle>
            <FormattedMessage id="app.confirm.question" />
          </DialogTitle>
          <DialogContent>
            <FormattedMessage id={textToConfirmation} />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleConfirmAccept}
              color="primary"
              variant="contained"
            >
              <FormattedMessage id="app.confirm" />
            </Button>
            <Button
              onClick={handleConfirmCancel}
              color="primary"
              variant="outlined"
            >
              <FormattedMessage id="app.cancel" />
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default React.memo(ActionDialog);
